import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { fireTrackAnalytics } from '@atlassian/jira-product-analytics-bridge';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { TicketTypeData } from '../../../common/types.tsx';
import { deleteTicketTypeService } from '../../../services/delete-ticket-type/index.tsx';

const deleteTicketType =
	(ticketTypeId: number, analyticsEvent: UIAnalyticsEvent): Action<TicketTypeData> =>
	async ({ getState, setState }) => {
		const {
			ticketTypes,
			appProps: { projectId },
		} = getState();

		const id = `${ticketTypeId}`;

		if (ticketTypes[id] !== undefined) {
			const toBeDeletedTicketType = ticketTypes[id].currentState;
			setState({
				pendingTicketTypeDeletion: { error: null, data: id },
			});

			try {
				await deleteTicketTypeService(toBeDeletedTicketType, projectId);
				const { ticketTypes: existingTicketTypes } = getState();
				const updatedTicketTypes = { ...existingTicketTypes };
				delete updatedTicketTypes[id];
				setState({
					ticketTypes: updatedTicketTypes,
					pendingTicketTypeDeletion: { error: null, data: null },
				});
				fireTrackAnalytics(analyticsEvent, 'requestType deleted');
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				setState({
					pendingTicketTypeDeletion: {
						error,
						data: id,
					},
				});
				fireErrorAnalytics({
					event: analyticsEvent,
					meta: {
						id: 'deleteTicketTypeService',
						packageName: 'jiraServicedeskTicketTypesStore',
					},
					error,
				});
			}
		}
	};

export default deleteTicketType;
